import { DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton, Spinner, SpinnerSize } from 'office-ui-fabric-react'
import * as React from 'react'

export interface IDeleteDialogProps {
    title?: string;
    subText?: string;
    showDialog: boolean;
    onDeleteClick();
    onDismissClick();
}

export default function DeleteDialog(props: IDeleteDialogProps) {
    const dialogContentProps = {
        type: DialogType.normal,
        title: props.title ? props.title : 'Slett element',
        closeButtonAriaLabel: 'Avbryt',
        subText: props.subText ? props.subText : 'Vil du virkelig slette dette elementet',
        styles: {
            subText: {
                fontSize: "15px"
            }
        }
      };

    return (
        <div>
            <Dialog
                hidden={!props.showDialog}
                onDismiss={() => props.onDismissClick()}
                dialogContentProps={dialogContentProps}
            >
                <DialogFooter>
                  <PrimaryButton style={{backgroundColor: "#FF0000"}} onClick={() => {
                            props.onDeleteClick();
                        }
                    }> 
                    Slett
                   </PrimaryButton>
                  <DefaultButton onClick={() => props.onDismissClick()} text="Avbryt"/>
                </DialogFooter>
            </Dialog>
        </div>
    )
}
